module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Working Men Volume 1")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Gay Erotic Romance Box Set")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("12 Stories in 1 Collection!")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("By J.M. Snyder")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("TABLE OF CONTENTS:")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "id": "a5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005#a20"
    }
  }, [_vm._v("At Your Service")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "href": "#/006#a21"
    }
  }, [_vm._v("Café de l’Amour")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/007#a22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Car Trouble")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/008#a23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Closing Time")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/009#a24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easily Addicted")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/010#a25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lunch Break")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/011#a26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Makin’ Copies")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/012#a27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On the Job")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/013#a28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opening Day at the County Fair")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/014#a29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Order Up")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/015#a30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pleasure Cruise")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/016#a31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speed Trap")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/017#a32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer Kisses and Ice Cream Dreams")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/018#a33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tech Support")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df7843c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004.vue
// module id = 63
// module chunks = 0